import React, { useEffect } from 'react';
import { Widget } from '@typeform/embed-react';

interface Style {
  property: string;
  value: string;
}
interface TypeformWidgetProps {
  header: string;
  styles?: Style[];
}

const TypeformWidget = ({ header, styles = [] }: TypeformWidgetProps) => {
  useEffect(() => {
    const widgetContainer = document.querySelector('.tf-v1-widget') as HTMLDivElement;
    if (widgetContainer) {
      const heightStyle = styles?.find((style) => style.property === 'height') || { value: '32rem' };
      widgetContainer.style.height = heightStyle.value;
    }
  }, [header, styles]);

  return header ? <Widget id={header}/> : <div>Please add a Typeform id to the header</div>;
};

TypeformWidget.defaultProps = {
  styles: [],
};

export default TypeformWidget;
